// Externals
import React from "react";

// Styles
import "./Header.scss";

/*::
type Props = {}
*/
const Header = (props /*: Props */) /*: React.Component */ => {
	return (
		<>
		<div className="header-container">
			<header
				onClick={() =>
					(window.location.href = "https://www.rspcansw.org.au/")
				}
				className="header"
			>
				<h1 data-cy="h1">RSPCA</h1>
			</header>
			</div>
		</>
	);
};

// Exports
export default Header;
